// extracted by mini-css-extract-plugin
module.exports = {"layout":"_app_layout__RkNG3","center":"_app_center__4Gg05","navigation":"_app_navigation__qjGSV","footer":"_app_footer__OVYe4"};